import { render, staticRenderFns } from "./CloneLabelButton.vue?vue&type=template&id=10c2656a&"
import script from "./CloneLabelButton.vue?vue&type=script&lang=js&"
export * from "./CloneLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports